export default "__VITE_ASSET__Cyb8xWsO__"